// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"hotkeys_wrapper__29nuu","inner":"hotkeys_inner__3bMg9"};